'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var React = require('react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@emotion/react');
require('aviary-tokens');
require('../../internal/InternalSkeleton/InternalSkeleton.web.styles.cjs');
require('../../atoms/Typography/Typography.web.cjs');
var InternalButtonLink_web = require('../../internal/InternalButtonLink/InternalButtonLink.web.cjs');
var BottomBar_web = require('./BottomBar/BottomBar.web.cjs');
var CoreActions_web = require('./CoreActions/CoreActions.web.cjs');
var Info_web = require('./Info/Info.web.cjs');
var Media_web = require('./Media/Media.web.cjs');
var Price_web = require('./Price/Price.web.cjs');
var TopBar_web = require('./TopBar/TopBar.web.cjs');
var VariantDropdown_web = require('./VariantDropdown/VariantDropdown.web.cjs');
var ProductCard_web_styles = require('./ProductCard.web.styles.cjs');

/**
 * A Composable card component for anything that can be added to a plan or cart
 * ex: supplements, resources, labs, plan templates.
 *
 * {@link https://aviary.supernova-docs.io/latest/components/product-card/overview-HiO5C8i9 | Documentation}
 *
 * @scope Core
 */ const ProductCard = ({ children, onCardClick, isLoading = false, isFullWidth = false, to, href, ...rest })=>{
    const renderCompareCheckedStyles = ()=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === BottomBar_web.BottomBar && child.props.isCompareChecked) {
                return ProductCard_web_styles.compareChecked;
            }
        });
    };
    const wrapperStyles = [
        ProductCard_web_styles.productCard,
        isFullWidth && ProductCard_web_styles.fullWidth,
        renderCompareCheckedStyles
    ];
    const renderProductName = ()=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === Info_web.Info && child.props.name) {
                return child.props.name;
            }
        });
    };
    const renderVariant = ()=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === VariantDropdown_web.VariantDropdown && child.props.variants) {
                const currentVariant = child.props.variants.find((variant)=>variant.id === child.props.currentVariantId) || child.props.variants[0];
                return currentVariant.descriptor;
            }
        });
    };
    const renderChild = (childType)=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === childType) {
                if (isLoading) {
                    return /*#__PURE__*/ React.cloneElement(child, {
                        isLoading: true,
                        ...child.props
                    });
                }
                if (child.type === Media_web.Media) {
                    return /*#__PURE__*/ React.cloneElement(child, {
                        alt: `${renderProductName()} ` + `${renderVariant()}`,
                        ...child.props
                    });
                }
                return child;
            }
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: wrapperStyles,
        "aria-busy": isLoading,
        children: [
            (to || href || onCardClick) && !isLoading && /*#__PURE__*/ jsxRuntime.jsx(InternalButtonLink_web.InternalButtonLink, {
                onClick: onCardClick,
                "aria-label": renderProductName()?.toString(),
                to: to,
                href: href,
                ...rest,
                css: ProductCard_web_styles.productCardLink
            }),
            renderChild(TopBar_web.TopBar),
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: ProductCard_web_styles.innerWrapper,
                children: [
                    renderChild(Media_web.Media),
                    renderChild(Info_web.Info),
                    renderChild(VariantDropdown_web.VariantDropdown),
                    renderChild(Price_web.Price),
                    renderChild(CoreActions_web.CoreActions),
                    renderChild(BottomBar_web.BottomBar)
                ]
            })
        ]
    });
};
/**
 * Subcomponent of ProductCard, displays metadata about the product or service and secondary actions
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.TopBar = TopBar_web.TopBar;
/**
 * Subcomponent of ProductCard, displays the visual for the card
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.Media = Media_web.Media;
/**
 * Subcomponent of ProductCard, displays the name and brand/author of the product or service
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.Info = Info_web.Info;
/**
 * Subcomponent of ProductCard, displays a dropdown for variants and availability status of a product
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.VariantDropdown = VariantDropdown_web.VariantDropdown;
/**
 * Subcomponent of ProductCard, displays the cost of a product or service
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.Price = Price_web.Price;
/**
 * Subcomponent of ProductCard, displays core action(s) for the card
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.CoreActions = CoreActions_web.CoreActions;
/**
 * Subcomponent of ProductCard, displays warnings and compare checkbox
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.BottomBar = BottomBar_web.BottomBar;

exports.ProductCard = ProductCard;
//# sourceMappingURL=ProductCard.web.cjs.map
